import React, { KeyboardEvent, MouseEvent } from 'react';
import log from 'loglevel';
import { Search as BaseSearch } from '../../../ui';

function onUpdateQuery(query: string) {
	log.debug('Search - on update query:', query);
}

function onKeyUp(e: KeyboardEvent) {
	log.debug('Search - on key up:', e);
}

function onClickSearch(e: MouseEvent) {
	log.debug('Search - on click search:', e);
}

function onClickClear(e: MouseEvent) {
	log.debug('Search - on click clear:', e);
}

export const Search = () => (
	<>
		<h2 id="search">Search</h2>
		<BaseSearch
			onUpdateQuery={onUpdateQuery}
			onClickSearch={onClickSearch}
			onClickClear={onClickClear}
			onKeyUp={onKeyUp}
			placeholder="Type to search"
		/>
	</>
);
